import { TITLE_LIST } from "../utils/titleList";
import { FaCrown } from "react-icons/fa";

const TitleGallery = ({ userLevel, onClose }) => {
  const currentTitle =
    TITLE_LIST.find((title) => title.level === userLevel)?.title || "Unranked";
  const unlockedCount = TITLE_LIST.filter((title) => title.level <= userLevel).length;

  return (
    <div className="title-gallery">
      <div className="title-gallery__header">
        <div className="title-gallery__copy">
          <h2>
            <FaCrown style={{ color: "#ffd700", marginRight: 10, verticalAlign: -3 }} />
            Title Gallery
          </h2>
          <p className="title-gallery__helper">
            Review every rank title you have unlocked and see where the next ascent begins.
          </p>
        </div>
        {onClose && (
          <button type="button" className="solo-close" aria-label="Close Title Gallery" onClick={onClose}>
            ×
          </button>
        )}
      </div>

      <div className="title-gallery__summary">
        <div className="title-gallery__summary-card">
          <span className="title-gallery__summary-label">Current Title</span>
          <strong>{currentTitle}</strong>
        </div>
        <div className="title-gallery__summary-card">
          <span className="title-gallery__summary-label">Unlocked</span>
          <strong>
            {unlockedCount} / {TITLE_LIST.length}
          </strong>
        </div>
      </div>

      <div className="title-list">
        {TITLE_LIST.map((t) => (
          <div
            key={t.title}
            className={`title-row ${
              userLevel === t.level
                ? "title-current-row"
                : userLevel > t.level
                ? "title-unlocked"
                : "title-locked"
            }`}
          >
            <span className="title-level">{t.level < 10 ? `0${t.level}` : t.level}</span>
            <span className="title-label">{t.title}</span>
            {userLevel === t.level && <span className="title-current">Current</span>}
            {userLevel > t.level && <span className="title-earned">Cleared</span>}
            {userLevel < t.level && <span className="title-status">Locked</span>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TitleGallery;
